export enum Currency {
  UYU = 1,
  USD = 2,
}
